<template>
  <div>
    <p>{{ translationHint }}</p>
    <div>
      <b-button-group size="sm">
        <b-button @click="original">
          {{ originalLanguage }}
        </b-button>
        <b-button @click="translate">
          {{ $t('object:translate') }}
        </b-button>
      </b-button-group>
    </div>
  </div>
</template>
<script>
import { BButtonGroup, BButton } from 'bootstrap-vue';

export default {
  name: 'TranslatorHint',
  i18nOptions: { namespaces: ['common', 'object'] },
  components: { BButtonGroup, BButton },
  props: {
    srcLanguage: {
      type: String,
      required: true,
    },
  },
  computed: {
    activeLanguage() {
      return this.$store.state.app.currentLanguage;
    },
    currentLanguage() {
      return (this.$i18n.i18next.language || this.$store.state.app.currentLanguage) || 'it';
    },
    translationHint() {
      const languageString = this.$t(`object:languages.${this.currentLanguage}`);
      return this.$t('object:showTranslationHint', { language: languageString, ogLang: this.originalLanguage });
    },
    originalLanguage() {
      const languageString = `${this.$t('object:original')} (${this.$t(`object:languages.${this.srcLanguage}`)})`;
      return languageString;
    },
  },
  methods: {
    translate() {
      this.$emit('lang-changed', this.currentLanguage);
    },
    original() {
      this.$emit('lang-changed', this.srcLanguage);
    },
  },
};
</script>
